import { ReportSettingLogoOption } from "@common/types/reports/report-settings";

export type PreviewLogo =
    | { kind: "image"; src: string; alt: string }
    | { kind: "placeholder"; label: string };

interface VisiblePreviewLogosParams {
    logoOption: ReportSettingLogoOption;
    firmLogoUrl: string | null;
    entityLogoUrl: string | null;
}

export const getVisiblePreviewLogos = ({
    logoOption,
    firmLogoUrl,
    entityLogoUrl,
}: VisiblePreviewLogosParams): PreviewLogo[] => {
    const shouldShowFirm =
        logoOption === ReportSettingLogoOption.FIRM ||
        logoOption === ReportSettingLogoOption.BOTH;
    const shouldShowEntity =
        logoOption === ReportSettingLogoOption.ENTITY ||
        logoOption === ReportSettingLogoOption.BOTH;

    const logos: PreviewLogo[] = [];
    if (shouldShowFirm) {
        logos.push(
            firmLogoUrl
                ? { kind: "image", src: firmLogoUrl, alt: "Firm logo" }
                : { kind: "placeholder", label: "Firm logo" },
        );
    }
    if (shouldShowEntity) {
        logos.push(
            entityLogoUrl
                ? { kind: "image", src: entityLogoUrl, alt: "Entity logo" }
                : { kind: "placeholder", label: "Entity logo" },
        );
    }
    return logos;
};
